import React, { useState } from 'react';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import ReceiptIcon from '@mui/icons-material/Receipt';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { Modal, Box, Typography, IconButton } from '@mui/material';
import AssessmentReceipt from '../../img/AssessmentReceipt.png'

export default function TransactionItem({ transaction, TimeZoneHandler, userType }) {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
  };

  const formatDateTime = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';

    hours = hours % 12 || 12;

    return `${day}/${month}/${year} • ${hours}:${minutes} ${ampm}`;
  };

  return (
    <>
      <div key={transaction.id} className="d-flex justify-content-between">
        <div>
          <h6 className="fw-bold text-purple mb-4">
            <ReceiptLongIcon style={{ color: "#813CCA" }} /> {transaction.assess_name}
          </h6>
          <div className='row mb-2'><span className="text-success">Paid –</span><p>{transaction.paid_by}</p></div>
          {transaction.amount && (
          <p className="mb-2">
            <ReceiptIcon style={{ color: "#42A5F5" }} /> Amount : <strong>{transaction.symbol} {transaction.amount}</strong>
          </p>
          )}
          {userType === "parent" && (
            <>
            <small className="">
              Student : {transaction.student}
            </small>
            <br />
            </>
          )}
          <small className="mb-2">
            {/* Purchased on : {TimeZoneHandler.convertTime(transaction.created_at)} */}
            Purchased on : {formatDateTime(transaction.created_at)}
          </small>
        </div>
        <div className="d-flex flex-column justify-content-between">
          <div>
            <IconButton onClick={handleOpen} >
              <RemoveRedEyeIcon />
            </IconButton>
          </div>
          <div>
            <img src={AssessmentReceipt} alt="icon" style={{ width: '28px' }} />
          </div>
        </div>
      </div>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="transaction-modal-title"
        aria-describedby="transaction-modal-description"
      >
        <Box sx={modalStyle}>
          <Typography id="transaction-modal-title" variant="h6" component="h2">
          More Details
          </Typography>
          <Typography id="transaction-modal-description" sx={{ mt: 2 }}>
            <strong>Confirmation No:</strong> {transaction.exam_transaction_id} <br />
            <strong>Payment Method:</strong> {transaction.payment_method} <br />
            {userType === "parent" && (
            <>
            <strong>Student ID:</strong> {transaction.user_code} <br />
            </>
            )}
          </Typography>
        </Box>
      </Modal>
    </>
  );
}
